export default function getAppContainerId(): string {
  if (Object.hasOwnProperty.call(process.env, 'REACT_APP_CONTAINER_ID') && process.env.REACT_APP_CONTAINER_ID.trim() !== '') {
    return process.env.REACT_APP_CONTAINER_ID;
  }
  return 'app';
}
